// Shopify Iframe Integration Script
// Add this script to your Shopify store where you embed the iframe

(function() {
  'use strict';

  // Configuration
  const IFRAME_SELECTOR = 'iframe[src*="lovableproject.com"]'; // Adjust selector if needed
  const MIN_HEIGHT = 600;
  const RESIZE_DEBOUNCE = 100;

  let resizeTimeout;

  function debounce(func, wait) {
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(resizeTimeout);
        func(...args);
      };
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(later, wait);
    };
  }

  function initializeIframe(iframe) {
    // Set initial styles for smooth scrolling
    iframe.style.cssText = `
      width: 100%;
      border: none;
      overflow: hidden;
      display: block;
      min-height: ${MIN_HEIGHT}px;
      -webkit-overflow-scrolling: touch;
      scroll-behavior: smooth;
    `;

    // Add loading state
    iframe.setAttribute('loading', 'lazy');

    // Listen for height messages from the iframe
    const handleMessage = (event) => {
      if (!event.data || event.data.type !== 'ALVN_HEIGHT_UPDATE') return;
      if (event.data.source !== 'alvn-embed') return;

      const newHeight = Math.max(event.data.height, MIN_HEIGHT);

      // Smooth height transition
      iframe.style.transition = 'height 0.3s ease-out';
      iframe.style.height = `${newHeight}px`;

      // Remove transition after animation
      setTimeout(() => {
        iframe.style.transition = '';
      }, 300);
    };

    window.addEventListener('message', handleMessage);

    // Handle iframe load
    iframe.addEventListener('load', () => {
      iframe.classList.add('alvn-iframe-loaded');

      iframe.contentWindow.postMessage({
        type: 'ALVN_PARENT_CONFIG',
        config: {
          shopify: true,
          mobile: window.innerWidth <= 768
        }
      }, '*');
    });

    // Mobile-specific optimizations
    if (window.innerWidth <= 768) {
      iframe.classList.add('alvn-mobile-iframe');
      iframe.style.touchAction = 'pan-y';

      const container = iframe.parentElement;
      if (container) {
        container.style.cssText += `
          -webkit-overflow-scrolling: touch;
          overflow: hidden;
          position: relative;
        `;
      }
    }

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }

  function initialize() {
    const iframes = document.querySelectorAll(IFRAME_SELECTOR);
    const cleanupFunctions = [];

    iframes.forEach(iframe => {
      const cleanup = initializeIframe(iframe);
      cleanupFunctions.push(cleanup);
    });

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const newIframes = node.matches?.(IFRAME_SELECTOR)
              ? [node]
              : Array.from(node.querySelectorAll?.(IFRAME_SELECTOR) || []);

            newIframes.forEach(iframe => {
              const cleanup = initializeIframe(iframe);
              cleanupFunctions.push(cleanup);
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    const handleResize = debounce(() => {
      const iframes = document.querySelectorAll(IFRAME_SELECTOR);
      iframes.forEach(iframe => {
        iframe.contentWindow?.postMessage({
          type: 'ALVN_RESIZE',
          width: window.innerWidth,
          mobile: window.innerWidth <= 768
        }, '*');
      });
    }, RESIZE_DEBOUNCE);

    window.addEventListener('resize', handleResize);

    return () => {
      cleanupFunctions.forEach(cleanup => cleanup());
      observer.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  // CSS for smooth iframe experience
  const style = document.createElement('style');
  style.textContent = `
    ${IFRAME_SELECTOR} {
      transition: height 0.3s ease-out;
      max-width: 100%;
    }

    .alvn-iframe-loaded {
      opacity: 1;
    }

    .alvn-mobile-iframe {
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: none;
    }

    @media (max-width: 768px) {
      ${IFRAME_SELECTOR} {
        width: 100% !important;
        min-height: 500px;
      }
    }
  `;
  document.head.appendChild(style);
})();